<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true" :text="uploadMsg">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-row>
      <b-col cols="12" lg="12">
        <b-card no-header>
          <template slot="header">
            <b>Add New Report</b>
          </template>
          <b-row>
            <b-col>
              <span>
                <b>
                  Report Id :
                  <span style="color:#0099ff">{{repoID}}</span>
                </b>
              </span>
            </b-col>
          </b-row>

          <b-row class="py-2 justify-content-md-center text-center">
            <b-col cols="12">
              <img v-if="newsuspectImage" :src="newsuspectImage" width="auto" height="150px" />
            </b-col>
          </b-row>
          <b-row class="py-2 justify-content-md-center">
            <b-col cols="12" md="3">
              <b-form-group label="Suspect Image">
                <b-form-file
                  v-model="suspectimage"
                  accept="image/png, image/jpeg, image/jpg"
                  placeholder="Select a file"
                  multiple
                  @change="showsuspectImage"
                ></b-form-file>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="justify-content-md-center">
            <b-col cols="12" md="9">
              <b-row class="justify-content-md-center">
                <b-col cols="12" md="4">
                  <div :class="{error: validation.hasError('lastname')}">
                    <b-form-group label="Suspect Last Name *">
                      <b-form-input
                        v-model="lastname"
                        type="text"
                        id="lastname"
                        placeholder="Last Name"
                      ></b-form-input>
                      <template slot="description" v-if="validation.firstError('lastname')">
                        <span style="color:red;">{{validation.firstError('lastname')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div :class="{error: validation.hasError('firstname')}">
                    <b-form-group label="Suspect First Name *">
                      <b-form-input
                        v-model="firstname"
                        type="text"
                        id="firstname"
                        placeholder="First Name"
                      ></b-form-input>
                      <template slot="description" v-if="validation.firstError('firstname')">
                        <span style="color:red;">{{validation.firstError('firstname')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <!-- <div :class="{error: validation.hasError('middlename')}"> -->
                  <b-form-group label="Suspect Middle Name">
                    <b-form-input
                      v-model="middlename"
                      type="text"
                      id="middlename"
                      placeholder="Middle Name"
                    ></b-form-input>
                    <!-- <template slot="description" v-if="validation.firstError('middlename')">
                        <span style="color:red;">{{validation.firstError('middlename')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>

                <b-col cols="12" md="4">
                  <div :class="{error: validation.hasError('country')}">
                    <b-form-group label="Country *">
                      <b-form-select v-model="country" :options="countrylist"></b-form-select>
                      <template slot="description" v-if="validation.firstError('country')">
                        <span style="color:red;">{{validation.firstError('country')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div :class="{error: validation.hasError('nationality')}">
                    <b-form-group label="Nationality *">
                      <b-form-select v-model="nationality" :options="nationlist"></b-form-select>
                      <template slot="description" v-if="validation.firstError('nationality')">
                        <span style="color:red;">{{validation.firstError('nationality')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="4">
                  <div :class="{error: validation.hasError('dateofreport')}">
                    <b-form-group label="Date">
                      <b-form-input v-model="dateofreport" type="date" id="date"></b-form-input>
                      <template slot="description" v-if="validation.firstError('dateofreport')">
                        <span style="color:red;">{{validation.firstError('dateofreport')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>

                <b-col cols="12" md="12">
                  <div :class="{error: validation.hasError('lastknown')}">
                    <b-form-group label="Last Known Address *">
                      <b-form-textarea
                        id="lastknown"
                        v-model="lastknown"
                        placeholder
                        rows="3"
                        max-rows="6"
                      ></b-form-textarea>
                      <template slot="description" v-if="validation.firstError('lastknown')">
                        <span style="color:red;">{{validation.firstError('lastknown')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>

                <b-col cols="12" md="6" class="text-left">
                  <div :class="{error: validation.hasError('crimeType')}">
                    <b-form-group label="Type of Crime *">
                      <b-form-select
                        v-model="crimeType"
                        :options="crimeTypes"
                        text-field="cname"
                        value-field="_id"
                      ></b-form-select>
                      <template slot="description" v-if="validation.firstError('crimeType')">
                        <span style="color:red;">{{validation.firstError('crimeType')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>

                <b-col cols="12" md="12">
                  <div :class="{error: validation.hasError('crime')}">
                    <b-form-group label="Crime Synopsis *">
                      <b-form-textarea id="crime" v-model="crime" placeholder rows="3" max-rows="6"></b-form-textarea>
                      <template slot="description" v-if="validation.firstError('crime')">
                        <span style="color:red;">{{validation.firstError('crime')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>

                <b-col cols="12" md="12">
                  <b-form-group label="Keywords for Search">
                    <b-form-input
                      v-model="keywords"
                      type="text"
                      id="keywords"
                      placeholder="Use comma as separators between keywords"
                    ></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                  <b-form-group label="Business Name">
                    <b-form-input
                      v-model="Businessname"
                      type="text"
                      id="Businessname"
                      placeholder="Businessname"
                    ></b-form-input>
                  </b-form-group>
                </b-col>

                 <b-col cols="12" md="6">
                 
                </b-col>

                <b-col cols="12" md="6">
                  <div :class="{error: validation.hasError('cname')}">
                    <b-form-group label="Contributing Name *">
                      <b-form-input v-model="cname" id="cname" placeholder="Full Name"></b-form-input>
                      <template slot="description" v-if="validation.firstError('cname')">
                        <span style="color:red;">{{validation.firstError('cname')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="6">
                  <div :class="{error: validation.hasError('cemail')}">
                    <b-form-group label="Contributing Email *">
                      <b-form-input v-model="cemail" id="cemail" placeholder="Email"></b-form-input>
                      <template slot="description" v-if="validation.firstError('cemail')">
                        <span style="color:red;">{{validation.firstError('cemail')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="6">
                  <div :class="{error: validation.hasError('cphone')}">
                    <b-form-group label="Contributing Phone *">
                      <b-form-input v-model="cphone" id="cphone" placeholder="Phone Number"></b-form-input>
                      <template slot="description" v-if="validation.firstError('cphone')">
                        <span style="color:red;">{{validation.firstError('cphone')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="6">
                  <div :class="{error: validation.hasError('cagency')}">
                    <b-form-group label="Contributing Agency *">
                      <b-form-input v-model="cagency" id="cagency" placeholder="Agency"></b-form-input>
                      <template slot="description" v-if="validation.firstError('cagency')">
                        <span style="color:red;">{{validation.firstError('cagency')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="py-2 justify-content-md-center text-center">
            <b-col cols="12">
              <img v-if="newImage" :src="newImage" width="auto" height="150px" />
            </b-col>
          </b-row>

          <b-row class="justify-content-md-center">
            <b-col cols="12" md="9">
              <span class="item_title" style="font-size:18px;font-weight:bold">Other Attachments</span>
            </b-col>
            <b-col cols="12" md="9">
              <div ref="messageDisplay" id="messages" v-for="(item,i) in productinfo" :key="i">
                <b-row>
                  <b-col cols="12" md="6">
                    <b-form-group>
                      <b-form-select v-model="item.attachType" :options="attachmenttypes"></b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-form-group>
                      <b-form-file
                        id="fileInput"
                        :plain="false"
                        v-model="item.value"
                        @change="showImage"
                      ></b-form-file>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" md="10"></b-col>
                  <b-col cols="12" md="2" style="text-align:right">
                    <span v-if="i == ''">
                      <p style="color:#ff4e00" dark @click="update">
                        <router-link to style="color:primary;padding-left:10px;">Add More</router-link>
                      </p>
                    </span>
                    <span v-if="i>0">
                      <p style="color:#ff4e00" dark @click="removee(i)">
                        <router-link to style="color:primary;padding-left:40px;">Close</router-link>
                      </p>
                    </span>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="userRole == 'admin'" class="py-2 justify-content-md-center">
            <b-form-checkbox
              id="checkbox-status"
              v-model="Confidential"
            >Check to make the report ”Strictly Confidential”, only the Admins can access and see.</b-form-checkbox>
          </b-row>
          <b-row class="py-2 justify-content-md-center">
            <span style="color:red">{{msg}}</span>
          </b-row>
          <b-row class="justify-content-center">
            <div class="px-2">
              <b-button variant="outline-primary" size="sm" @click.prevent="inputCheck">Submit</b-button>
            </div>
          </b-row>
          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// // Import FilePond
// import vueFilePond from "vue-filepond";

// // Import plugins
// import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js";
// import FilePondPluginImagePreview from "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js";

// // Import styles
// import "filepond/dist/filepond.min.css";
// import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

// // Create FilePond component
// const FilePond = vueFilePond(
//   FilePondPluginFileValidateType,
//   FilePondPluginImagePreview
// );
export default {
  // components: {
  //   FilePond,
  // },
  data() {
    return {
      ServerError: false,
      appLoading: false,
      uploadMsg: "",
      myFiles: [],
      msg: null,
      repoID: null,
      lastname: null,
      firstname: null,
      middlename: null,
      country: null,
      nationality: null,
      dateofreport: new Date().toISOString().substr(0, 10),
      lastknown: null,
      crimeType: null,
      keywords: null,
      crime: null,
      Businessname:null,
      cname: null,
      cemail: null,
      cphone: null,
      cagency: null,
      image: null,
      suspectimage: null,
      newsuspectImage: null,
      Confidential: false,
      newImage: null,
      reportid: null,
      countrylist: [],
      nationlist: [],
      crimeTypes: [],
      finalattachmentDetails: [],
      attachmentset: [],
      formupdate:false,
      suspectupload:false,
      attachupload:false,
      attachmentsformData: new FormData(),
      attachmenttypes: [
        { text: "Case Report", value: "casereport" },
        { text: "Fingerprints", value: "fingerprints" },
        { text: "Photos", value: "photos" },
        { text: "Other", value: "others" },
      ],
      productinfo: [
        {
          attachType: "",
          originalName: null,
          value: null,
        },
      ],
      attachments: [],
      userRole: localStorage.getItem("role"),
    };
  },
  watch:{
    formupdate(){
      if(this.formupdate == false &&
      this.suspectupload == false &&
      this.attachupload == false)
      {
      this.appLoading = false;
      this.$router.push("Reports/" + this.reportid);
      }
      
      else
      this.appLoading = true;
    },
    suspectupload(){
      if(this.formupdate == false &&
      this.suspectupload == false &&
      this.attachupload == false)
      {
      this.appLoading = false;
      this.$router.push("Reports/" + this.reportid);
      }
      else
      this.appLoading = true;
    },
     attachupload(){
      if(this.formupdate == false &&
      this.suspectupload == false &&
      this.attachupload == false)
      {
      this.appLoading = false;
      this.$router.push("Reports/" + this.reportid);
      }
      else
      this.appLoading = true;
    }
  },
  validators: {
    lastname(value) {
      return this.Validator.value(value).required("Required Field");
    },
    firstname(value) {
      return this.Validator.value(value).required("Required Field");
    },
    // middlename(value) {
    //   return this.Validator.value(value).required("Required Field");
    // },
    country(value) {
      return this.Validator.value(value).required("Required Field");
    },
    nationality(value) {
      return this.Validator.value(value).required("Required Field");
    },
    lastknown(value) {
      return this.Validator.value(value).required("Required Field");
    },
    crimeType(value) {
      return this.Validator.value(value).required("Required Field");
    },
    crime(value) {
      return this.Validator.value(value).required("Required Field");
    },
    dateofreport(value) {
      return this.Validator.value(value).required("Required Field");
    },
    cname(value) {
      return this.Validator.value(value).required("Required Field");
    },
    cemail(value) {
      return this.Validator.value(value).required("Required Field").email();
    },
    cphone(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .regex("^[0-9]*$", "Please Input Valid Number.");
    },
    cagency(value) {
      return this.Validator.value(value).required("Required Field");
    },
  },
  mounted() {
    this.getreportId();
    this.getcrimeType();
    this.getcountrylist();
    this.getnationlist();
  },

  methods: {
    inputCheck() {
      for (var i = 0; i < this.productinfo.length; i++) {
        if (this.productinfo[i].value != null) {
          this.productinfo[i].originalName = this.productinfo[i].value.name;
          this.productinfo[i].value = null;
        }
      }
      // console.log(this.productinfo);
      this.msg = null;
      this.$validate().then((success) => {
        if (success) {
          this.addSuspect();
        } else {
          this.msg = "Please validate input fields";
          return;
        }
      });
    },

    getreportId() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/available/reportid",
      })
        .then((response) => {
          this.appLoading = false;
          this.repoID = response.data.data;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    getcrimeType() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/crimetype/list",
      })
        .then((response) => {
          this.appLoading = false;
          this.crimeTypes = response.data.data;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    getcountrylist() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/countries",
      })
        .then((response) => {
          this.appLoading = false;
          this.countrylist = response.data.data;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    getnationlist() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/nationalities",
        // params: {
        //   id: this.$route.params.id,
        // },
        // headers: {
        //   "x-auth-token": localStorage.getItem("token"),
        // },
      })
        .then((response) => {
          this.appLoading = false;
          this.nationlist = response.data.data;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    addSuspect() {
      this.formupdate=true;
      var suspect = {};
      suspect["suspectLastName"] = this.lastname;
      suspect["suspectFirstName"] = this.firstname;
      suspect["suspectMiddleName"] = this.middlename;
      suspect["knownAddress"] = this.lastknown;
      suspect["country"] = this.country;
      suspect["nationality"] = this.nationality;
      suspect["added_date"] = this.dateofreport;
      suspect["crimeSynopsis"] = this.crime;
      suspect["businessName"] = this.Businessname;
      suspect["contributingName"] = this.cname;
      suspect["contributingEmail"] = this.cemail;
      suspect["contributingPhone"] = this.cphone;
      suspect["contributingAgency"] = this.cagency;
      suspect["searchKeywords"] = this.keywords;
      suspect["crimeTypeId"] = this.crimeType;
      suspect["isConfidential"] = this.Confidential;
      axios({
        method: "POST",
        url: "/report/add",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: suspect,
      })
        .then((response) => {
          //this.appLoading = false;
          
          if (response.data.status) {
            this.reportid = response.data.Rid;
            var isok = false;
            if (this.suspectimage) {
              isok = true;
              this.uploadsuspectImage(this.productinfo.length);
            }
            if (this.attachmentset.length > 0) {
              console.log(this.attachmentset.length)
              isok = true;
              for (var i = 0; i < this.attachmentset.length; i++) {
                this.attachmentsformData.append(
                  "attachments",
                  this.attachmentset[i]
                );
              }
              this.uploadattachments();
            }

            // if (isok == false) {
            //   this.$router.go(-1);
            // }
          } else {
            this.msg = response.data.msg;
          }
          this.formupdate=false;
        })
        .catch((err) => {

          this.appLoading = false;
          this.ServerError = true;
        });
    },
    update() {
      this.productinfo.push({
        attachType: null,
        originalName: null,
        value: null,
      });
      // console.log(this.productinfo)
    },
    removee(index) {
      this.productinfo.splice(index, 1);
      this.attachments.splice(index, 1);
      this.attachmentset.splice(index, 1);
    },

    showsuspectImage(e) {
      var files = e.target.files || e.dataTransfer.files;
      var fileData = event.target.files[0];
      var fileName = fileData.name;

      if (!files.length) {
        this.newsuspectImage = null;
        return;
      }
      if (files[0].size > 5242880) {
        this.msg = "File size Should be less than 5MB";
        return;
      }
      var reader = new FileReader();
      reader.onload = (e) => {
        this.newsuspectImage = e.target.result;
      };
      reader.readAsDataURL(files[0]);
    },

    showImage(e) {
      var files = e.target.files || e.dataTransfer.files;
      var fileData = event.target.files[0];
      var selectedFiles = e.target.files[0];
      var fileName = fileData.name;
      var filetype = fileData.type;
      // console.log(fileData)
      // console.log(selectedFiles)
      if (!files.length) {
        this.newImage = null;
        return;
      }
      if (files[0].size > 5242880) {
        this.msg = "File size Should be less than 5MB";

        return;
      } else {
        this.msg = null;
        this.attachmentset.push(selectedFiles);
        // this.attachmentsformData.append("attachments", selectedFiles);
      }
      var reader = new FileReader();
      reader.onload = (e) => {
        if (filetype === "image/png" || "image/jpg" || "image/jpeg")
          this.newImage = e.target.result;
      };
      reader.readAsDataURL(files[0]);
    },

    uploadsuspectImage(count) {
      var vm = this;

      //this.appLoading = true;
      this.suspectupload=true;
      let formData = new FormData();
      formData.append("photo", vm.suspectimage[0]);

      axios({
        method: "POST",
        url: "/report/upload/photo/" + this.reportid,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
        data: formData,
        onUploadProgress: function (progressEvent) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          // vm.uploadMsg = "Uploading " + percentCompleted + "%";
          // if (percentCompleted == 100) vm.uploadMsg = "";
        },
      })
        .then((response) => {
         // this.appLoading = false;
         this.suspectupload=false;
          // if (this.attachmentset.length == 0 ) 
          // this.$router.push("Reports/" + this.reportid);
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },

    uploadattachments() {
      var vm = this;
     //this.appLoading = true;
     this.attachupload=true;
      var data = {};
      this.attachmentsformData.append(
        "attachmentDetails",
        JSON.stringify(this.productinfo)
      );
      axios({
        method: "POST",
        url: "/report/upload/attachments/" + this.reportid,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },

        data: this.attachmentsformData,
        onUploadProgress: function (progressEvent) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
            //this.appLoading = true;
          // vm.uploadMsg = "Uploading " + percentCompleted + "%";
          if (percentCompleted == 100) {
            // this.appLoading = false;
            vm.uploadMsg = "";
          }
        },
      })
        .then((response) => {
          //this.appLoading = false;
          this.attachupload=false;
          
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },
  },
};
</script>
